import styles from '../../assets/styles/LandingPage/Header.module.scss';
import React, { useEffect, useState } from 'react';
import { PageLoader } from '../../components';
import { useTheme } from '../../context/ThemeContext';

const LandingPage = () => {
	const { theme } = useTheme();
	const [ThemeHomeComponent, setThemeHomeComponent] = useState(null);

	useEffect(() => {
		const loadThemeHomeComponent = async () => {
			try {
				const themeConfig = await import(
					`../../themes/${theme}/theme.config.js`
				);
				const HomeComponent = themeConfig.default.components.Home;
				setThemeHomeComponent(() => HomeComponent);
			} catch (error) {
				console.error('Failed to load theme home component', error);
				setThemeHomeComponent(null);
			}
		};

		loadThemeHomeComponent();
	}, [theme]);

	return (
		<main className={styles.main}>
			{ThemeHomeComponent ? <ThemeHomeComponent /> : <PageLoader />}
		</main>
	);
};

export default LandingPage;
